/* Dansk katalog for locale-closing-sales-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'route.arsavslutning-salg': 'Salg',
  'clo.sales.title': 'Salg',
  'clo.sales.openReview': 'Se salgskontrollen',
  'clo.sales.year': 'Indkomstår {{year}}',
  'clo.sales.subtitle': 'Automatisk kontrol af udkast og mangler i salgsdokumenter for {{year}}.',
  'clo.sales.pending': 'Salgsdokumenter, der skal behandles, før salgstrinnet for {{year}} er klar: {{count}}.',
  'clo.sales.ready': 'Dokumentkontrollen for {{year}} er fuldført automatisk. Ingen udkast eller mangler fundet.',
  'clo.sales.followUp': 'Salgsdokumenterne for {{year}} har bestået bogføringskontrollen. Udsendelser, der bør følges op: {{followUps}}.',
  'clo.sales.unsupported': 'Salgstrinnet understøttes ikke for dette land, regelsæt eller år.',
  'clo.sales.issuesTitle': 'Udkast og mangler',
  'clo.sales.noIssues': 'Ingen udkast eller mangelfulde salgsdokumenter i denne kontrol.',
  'clo.sales.draft': 'Udkast skal færdiggøres eller fjernes, hvis salget ikke skal gennemføres.',
  'clo.sales.undated': 'Mangler gyldig dokumentdato. Afklar, hvilket år salget hører til.',
  'clo.sales.incomplete': 'Dokumentgrundlaget er ufuldstændigt. Kontrollér nummer, linjer og beskrivelse.',
  'clo.sales.unknownDate': 'År skal afklares',
  'clo.sales.followUpsTitle': 'Følg op på udsendelse',
  'clo.sales.unsent': 'Ingen udsendelse registreret i Plumme',
  'clo.sales.deliveryFailed': 'Seneste e-mail kom ikke frem eller blev afvist',
  'clo.sales.sendingHelp': 'Kontrollér, at kunden har modtaget dokumentet. Udsendelse vises separat fra bogføring: dokumenter kan være leveret uden for Plumme, og e-mailstatus dokumenterer ikke, hvornår indtægten er optjent.',
  'clo.sales.receivablesTitle': 'Åbne kundeposter pr. 31.12.{{year}}',
  'clo.sales.receivablesHelp': 'Viser fakturaer og kreditnotaer i Plumme, der stod åbne ved årsskiftet, også fra tidligere år. Senere betalinger ændrer ikke beløbet pr. 31.12. Dette er ikke en fuld afstemning af konto 1500 eller importeret historik.',
  'clo.sales.settledAfter': 'Udlignet efter årsskiftet: {{amount}}',
  'clo.sales.noReceivables': 'Ingen åbne kundeposter fundet i dette grundlag ved årsskiftet.',
  'clo.sales.otherSalesTitle': 'Andre bogførte salg',
  'clo.sales.invoiceListTitle': 'Fakturaliste',
  'clo.sales.approveWithoutChanges': 'Godkend uden ændringer',
  'clo.sales.otherSale': 'Andet salg',
  'clo.sales.invoice': 'Faktura',
  'clo.sales.credit': 'Kreditnota',
  'clo.sales.openDocument': 'Åbn dokumentet',
  'clo.sales.openList': 'Åbn fakturalisten',
  'clo.sales.scopeHelp': 'Dokumentdatoen afgør, hvilke salg der vises. Udaterede dokumenter skal afklares; oprettelsesdato bruges ikke som salgsdato. Tilbud og ordrebekræftelser er ikke automatisk optjent salg. Periodisering, manglende fakturering, tab, valuta og fuld afstemning vurderes i separate kontroller.',
  'clo.sales.back': 'Tilbage til salgskontrollen',
  'clo.sales.backToClosing': 'Tilbage til årsafslutning',
  'clo.sales.loadError': 'Kunne ikke åbne salgsvisningen.',
  'clo.sales.documentGone': 'Dokumentet findes ikke længere i fakturalisten. Gå tilbage for en opdateret kontrol.',
});
